define('OutSystems/ClientRuntime/RequireManager',["require", "exports", "./Settings"], function (require, exports, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.configure = exports.loadModule = exports.setErrorHandler = exports.initialize = exports.setModuleIdToUrlMap = void 0;
    var BUNDLE_SEPARATOR_CHAR = "$";
    var REQUIRE_TYPE_SCRIPT_ERROR = "scripterror";
    var moduleIdToUrlMap;
    function setModuleIdToUrlMap(newModuleIdToUrlMap) {
        moduleIdToUrlMap = newModuleIdToUrlMap;
    }
    exports.setModuleIdToUrlMap = setModuleIdToUrlMap;
    function initialize() {
        ensureInitialized();
    }
    exports.initialize = initialize;
    function ensureInitialized() {
        ensureContextsArePatched();
    }
    function setErrorHandler(handler) {
        requirejs.onError = handler;
    }
    exports.setErrorHandler = setErrorHandler;
    function isRetryNeeded(error) {
        return error.requireType === REQUIRE_TYPE_SCRIPT_ERROR;
    }
    function tryUndefineErroneousModule(error) {
        var _a, _b;
        var requireError = error;
        var moduleIds = (_a = requireError.requireModules) === null || _a === void 0 ? void 0 : _a.concat((_b = requireError.parentModules) !== null && _b !== void 0 ? _b : []);
        if (!moduleIds && (moduleIds === null || moduleIds === void 0 ? void 0 : moduleIds.length) <= 0) {
            return false;
        }
        moduleIds.forEach(function (element) {
            var _a;
            requirejs.undef(element);
            if (element.indexOf("$") === -1) {
                var modulePath = moduleIdToUrlMap[element];
                var pathConfig = (_a = {}, _a[element] = modulePath, _a);
                requirejs.config({
                    paths: pathConfig,
                });
            }
        });
        ensureInitialized();
        return true;
    }
    function loadModule(moduleNames, onReady, onError) {
        var CDNFilenameVersioning = Settings_1.getEnvParams().CDNFilenameVersioning;
        var retryAttempts = 5;
        function retryLoadModuleOrFail(remainingRetryAttempts, error) {
            var callOnError = function () {
                onError ? onError(error) : requirejs.onError(error);
            };
            var noRetryNeeded = !isRetryNeeded(error) || remainingRetryAttempts === 0;
            if (noRetryNeeded) {
                callOnError();
                return;
            }
            setTimeout(function () {
                var couldNotUndefineModules = !tryUndefineErroneousModule(error);
                if (couldNotUndefineModules) {
                    callOnError();
                    return;
                }
                requirejs(moduleNames, onReady, function (err) { return retryLoadModuleOrFail(remainingRetryAttempts - 1, err); });
            }, 0);
        }
        if (!CDNFilenameVersioning) {
            requirejs(moduleNames, onReady, onError);
        }
        else {
            requirejs(moduleNames, onReady, function (err) { return retryLoadModuleOrFail(retryAttempts, err); });
        }
    }
    exports.loadModule = loadModule;
    function configure(scriptMap, defaultScriptsDir) {
        if (defaultScriptsDir === void 0) { defaultScriptsDir = "scripts"; }
        moduleIdToUrlMap = scriptMap;
        var requireJsConfig = { baseUrl: defaultScriptsDir, paths: {}, waitSeconds: 30 };
        if (moduleIdToUrlMap) {
            for (var js in moduleIdToUrlMap) {
                if (requirejs.specified(js) || requirejs.defined(js)) {
                    delete moduleIdToUrlMap[js];
                }
            }
            requireJsConfig.paths = moduleIdToUrlMap;
        }
        requirejs.config(requireJsConfig);
        ensureInitialized();
    }
    exports.configure = configure;
    function ensureContextsArePatched() {
        var contexts = requirejs.s.contexts;
        Object.keys(contexts).forEach(function (key) {
            var context = contexts[key];
            if (!context._osNameToUrlPatched) {
                var oldNameToUrl_1 = context.nameToUrl;
                context.nameToUrl = function (moduleName, ext, skipExt) {
                    if (moduleName.indexOf(BUNDLE_SEPARATOR_CHAR) > 0 && moduleName.indexOf("?") === -1) {
                        moduleName = moduleName.split(BUNDLE_SEPARATOR_CHAR, 2)[0];
                    }
                    return oldNameToUrl_1.apply(context, [moduleName, ext, skipExt]);
                };
                context._osNameToUrlPatched = true;
            }
        });
    }
});
//# sourceMappingURL=RequireManager.js.map;
